const getCommonTrackingParams = props => ({
  appName: 'Acorns',
  screen: {
    width: window.innerWidth,
    height: window.innerHeight,
  },
  ...props,
});

export const EVENT_ACTIONS = {
  IDENTIFY: 'Identify',
  NAVIGATE_TO: 'Navigate to',
  COPY: 'Copy',
  DOWNLOAD: 'Download',
  TOGGLE: 'Toggle',
  OPEN: 'Open',
  CLOSE: 'Close',
  CANCEL: 'Cancel',
  REFRESH: 'Refresh',
  SET: 'Set',
  ZOOM_TO: 'Zoom to',
  LOAD: 'Load',
  DELETE: 'Delete',
  CREATE: 'Create',
  EDIT: 'Edit',
  START: 'Start',
  SAVE: 'Save',
  IMPORT: 'Import',
  DROP: 'Drop',
};

export const pageEvent = (props = {}) => {
  window.analytics.page('Acorns Page', getCommonTrackingParams(props));
};

export const trackEvent = (eventName, props = {}) => {
  window.analytics.track(
    `[acorns] ${eventName}`,
    getCommonTrackingParams(props),
  );
};

export const identify = user => {
  const identifyOptions = {
    Intercom: {
      hideDefaultLauncher: true,
    },
  };

  window.analytics.identify(
    user.user_id,
    {
      email: user.email,
      userId: user.user_id,
      organizationId: user.organization_id,
      programId: user.program_id,
      roleLevel: user.role_level,
      workspaceId: user.pl_workspace,
      projectId: user.pl_project,
      sh_user_id: user.sh_user_id,
      name: user.name,
      firstName: user.first_name,
      lastName: user.last_name,
    },
    identifyOptions,
    () => {
      trackEvent('App - Identify User', {
        appSection: 'App',
        action: EVENT_ACTIONS.IDENTIFY,
        target: 'User',
      });
    },
  );
};

export const reset = () => analytics.reset();
